/** Yönetim sayfasında vitrin yükleyicisini engeller; harici mağazanın aynı adlı yollarını ayırır. */
export function isAdminAssistantHost(host=globalThis.window, document=host?.document, source=document?.currentScript?.src) {
  if(document?.querySelector?.('meta[name="onepage-page-context"]')?.content==='admin')return true;
  try {
    const page=new URL(host.location.href);
    const first=decodeURIComponent(page.pathname).split('/').filter(Boolean)[0]?.toLowerCase();
    if(first!=='panel' || !source)return false;
    return new URL(source,page.href).origin===page.origin;
  }catch{return false;}
}
